import { WelcomePropertyModal } from '$src/components/property/WelcomePropertyModal'
import { useState } from 'react'

export function usePropertyCreation() {
  const [welcomeModalState, setWelcomeModalState] = useState<{
    opened: boolean
    propertyId: number | null
    propertyAddress: string
  }>({
    opened: false,
    propertyId: null,
    propertyAddress: '',
  })

  const handlePropertyCreated = (
    propertyId: number,
    propertyAddress: string,
  ) => {
    setWelcomeModalState({
      opened: true,
      propertyId,
      propertyAddress,
    })
  }

  const closeWelcomeModal = () => {
    setWelcomeModalState({
      opened: false,
      propertyId: null,
      propertyAddress: '',
    })
  }

  const WelcomeModal = welcomeModalState.propertyId ? (
    <WelcomePropertyModal
      opened={welcomeModalState.opened}
      onClose={closeWelcomeModal}
      propertyId={welcomeModalState.propertyId}
      propertyAddress={welcomeModalState.propertyAddress}
    />
  ) : null

  return {
    handlePropertyCreated,
    WelcomeModal,
  }
}
